import { IDatePicker } from "domain/Utils/models/IDatePicker";
import { SBTranslate } from "i18n";
import { DateTime } from "luxon";
import { SBBox, SBTypography } from "modules/Commons";
import { useContext, useState } from "react";
import SBDatePickerMenu from "views/Commons/SBDatePickerMenu";
import { TipsContext } from "views/ConfigsView/ConfigTips";
export default (props: ConfigModifierPeriodProps) => {
	const { startDate, endDate, onChange } = props;
	const tipsContext = useContext(TipsContext);
	const [picker, setPicker] = useState<IDatePicker>({
		range: {
			startDate,
			endDate,
		}
	});
	const handleOnChangePicker = (value: IDatePicker) => {
		setPicker(value);
		onChange(value);
	};
	return (
		<SBBox>
			<SBTypography
				mb={1}
				fontSize="0.75rem"
				fontWeight="500"
				color="gray3.main"
				variant={"body1"}
				textTransform={"uppercase"}>
				{SBTranslate("period")}
			</SBTypography>
			<SBDatePickerMenu
				solo
				range
				useConfigMenuStyles
				showConfigOptions={false}
				startDate={picker.range?.startDate}
				endDate={picker.range?.endDate}
				onChange={handleOnChangePicker}
			/>
		</SBBox>
	);
};
interface ConfigModifierPeriodProps {
	startDate: DateTime | undefined,
	endDate: DateTime | undefined,
	onChange: (value: IDatePicker) => void
}

